import {NewDynamicTab } from "../../../components/Page";
import { HpgclTitle } from "../components";
import { TabSwitcher } from "../Hppc_Das";
import { HpgcDemandDefaultDates } from "../../../config/DefaultDates";
import { HaryanaDiscomAnalysis } from "./Discom_Analysis";
import { HaryanaTrend } from "./TrendAnalysis";
import { HaryanaForecast } from "./Forecast";

export function HppcDemand() {
  return (
    <>
      <NewDynamicTab
        defaultDates={HpgcDemandDefaultDates}
        minDate = '2015-01-01'
        headerPrefixComponent={<TabSwitcher />}
        header="Demand"
        trendTabs={["Trend Analysis", "Peak Analysis","Haryana Load","Forecast Haryana Load"]}
        middleComponent={<HpgclTitle />}
        tabs={{
          "Haryana Load": <HaryanaDiscomAnalysis />,
          "Trend Analysis": <HaryanaTrend />,
          "Forecast Haryana Load": <HaryanaForecast />,
          "Restricted demand": < HaryanaForecast/>,
          "Restricted demand Trend Analysis":<HaryanaForecast />,
        }}
      />
    </>
  );
}